"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toBeEmpty = toBeEmpty;

var _jestMatcherUtils = require("jest-matcher-utils");

var _utils = require("./utils");

function toBeEmpty(element) {
  (0, _utils.checkHtmlElement)(element, toBeEmpty, this);
  return {
    pass: element.innerHTML === '',
    message: () => {
      return [(0, _jestMatcherUtils.matcherHint)(`${this.isNot ? '.not' : ''}.toBeEmpty`, 'element', ''), '', 'Received:', `  ${(0, _jestMatcherUtils.printReceived)(element.innerHTML)}`].join('\n');
    }
  };
}